import React from "react";
import Detalle from "js/pages/Admin/Accion/Detalle";
import AuthService from "js/utils/AuthService";
const DetalleAccion = props => {
  const idPrograma = parseInt(AuthService.getIdPrograma());
  return <Detalle idPrograma={idPrograma} idAccion={props.idAccion} />;
};

export default DetalleAccion;
